import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { debounce } from "lodash";
import { GET_GUEST_SEARCH_REQUEST } from "../../../../../Utils/Constant";
import { getBaseUrl } from "../../../../../Redux/Config/AppConfig";

const CustomerForm = ({
  guestIndex,
  guestData,
  setGuestData,
  isViewOnly = false,
  onRemoveGuest,
  suggest,
  is_room,
  room_id,
}) => {
  const dispatch = useDispatch();
  const { guestSearch } = useSelector((state) => state.guestDetails);
  const [searchResults, setSearchResults] = useState([]);
  const [showSearchResults, setShowSearchResults] = useState(false);

  // Debounced search effect
  useEffect(() => {
    if (isViewOnly) return;

    const delayedSearch = debounce(() => {
      const { name, email, phone } = guestData;
      if (name || email || phone) {
        dispatch({
          type: GET_GUEST_SEARCH_REQUEST,
          payload: { name, email, phone, onOrderPage: true },
        });
      }
    }, 500);

    const delayedGuestForRoom = async (room_id) => {
      try {
        const BaseUrl = getBaseUrl();

        let token = localStorage.getItem("token");
        let hotel_id = localStorage.getItem("hotel_id");
        const response = await fetch(
          `${BaseUrl}/reservation/reservation-list/${room_id}?hotel_id=${hotel_id}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`, // ← Add your token here
            },
          }
        );
        const result = await response.json();
        
        if (result && result.data && result.data.guest) {
          let guest=result.data.guest;
          const selectedGuest = {
            name: `${guest.first_name || ""} ${
              guest.last_name || ""
            }`.trim(),
            email: guest.email || "",
            phone: guest.phone || "",
          };
          setGuestData(guestIndex, selectedGuest, guest?.id)
        }
      } catch (error) {}
    };

    if (!is_room) {
      delayedSearch();
    } else {
      if (room_id) delayedGuestForRoom(room_id);
    }

    return () => delayedSearch.cancel();
  }, [guestData, dispatch, is_room, room_id]);

  // Update search results when guestSearch changes
  useEffect(() => {
    const guests = guestSearch || [];
    if (guests.length > 0 && !isViewOnly) {
      setSearchResults(guests);
    } else {
      setShowSearchResults(false);
    }
  }, [guestSearch, isViewOnly]);

  const handleInputChange = (e) => {
    if (isViewOnly) return;

    const { name, value } = e.target;
    const updatedGuest = { ...guestData, [name]: value };
    setGuestData(guestIndex, updatedGuest);
    setShowSearchResults(true);
  };

  const handleGuestSelect = (guest) => {
    if (isViewOnly) return;

    const selectedGuest = {
      name: `${guest?.guest.first_name || ""} ${
        guest?.guest.last_name || ""
      }`.trim(),
      email: guest?.guest.email || "",
      phone: guest?.guest.phone || "",
    };
    let guest_id = guest?.guest?.id;

    setGuestData(guestIndex, selectedGuest, guest_id);
    setShowSearchResults(false);
  };

  const fields = [
    { label: "Name", name: "name", type: "text" },
    { label: "Email", name: "email", type: "email" },
    { label: "Phone", name: "phone", type: "text" },
  ];

  return (
    <div className="card mb-3">
      <div className="card-header d-flex justify-content-between align-items-center">
        <h5 className="card-title mb-0">Guest {guestIndex + 1}</h5>
        {!isViewOnly && onRemoveGuest && (
          <button
            type="button"
            className="btn btn-outline-danger btn-sm"
            onClick={() => onRemoveGuest(guestIndex)}
          >
            <i className="bi bi-x me-1"></i>
            Remove Guest
          </button>
        )}
      </div>
      <div className="card-body">
        <div className="row">
          {fields.map((field) => (
            <div key={field.name} className="col-md-6 mb-3">
              <label
                htmlFor={`${field?.name}_${guestIndex}`}
                className="form-label"
              >
                {field.label}
              </label>
              {isViewOnly ? (
                // <div className="form-control-plaintext bg-light p-2 rounded">
                //   {guestData[field?.name] || ""}
                // </div>
                <input
                  id={`${field.name}_${guestIndex}`}
                  name={field?.name}
                  type={field?.type}
                  className="form-control"
                  placeholder={field.label}
                  value={guestData[field?.name] || ""}
                  disabledOrder
                  Details
                  autoComplete="off"
                />
              ) : (
                <input
                  id={`${field.name}_${guestIndex}`}
                  name={field?.name}
                  type={field?.type}
                  className="form-control"
                  placeholder={field.label}
                  value={guestData[field?.name] || ""}
                  onChange={handleInputChange}
                  autoComplete="off"
                />
              )}
            </div>
          ))}
        </div>

        {!isViewOnly &&
          showSearchResults &&
          searchResults.length > 0 &&
          !suggest && (
            <div className="mt-3">
              <div className="border rounded p-3 bg-light">
                <strong className="small">Suggestions:</strong>
                <div className="mt-2">
                  {searchResults.map((guest, i) => (
                    <div
                      key={i}
                      onClick={() => handleGuestSelect(guest)}
                      className="p-2 bg-white rounded mb-1 small hover-bg-primary hover-text-white"
                      style={{ cursor: "pointer" }}
                    >
                      {`${guest?.guest?.first_name || ""} ${
                        guest?.guest?.last_name || ""
                      }`.trim()}{" "}
                      {guest?.guest.email && ` ( ${guest?.guest.email} ) `}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}
      </div>
    </div>
  );
};

export default CustomerForm;
